module.exports = __webpack_public_path__ + "static/sfv-bg-1129d2de8d8a1cd32cdce0f5fcde1eb5.jpg";